export const STEP_WELCOME_CLASS = 'klickbox-fluxogram-step-welcome';
export const STEP_MULTIPLE_CHOICE_CLASS = 'klickbox-fluxogram-step-multiple-choice';
export const STEP_YES_NO_CLASS = 'klickbox-fluxogram-step-yes-no';
export const STEP_FORM_EMAIL_CLASS = 'klickbox-fluxogram-step-form-email';
export const STEP_TEXT_CLASS = 'klickbox-fluxogram-step-text';
export const STEP_REDIRECT_CLASS = 'klickbox-fluxogram-step-redirect';
export const STEP_OPTION_CLASS = 'klickbox-fluxogram-step-option';
export const STEP_JUMP_CLASS = 'klickbox-fluxogram-step-jump';
export const STEP_THANKS_CLASS = 'klickbox-fluxogram-step-thanks';

export const STEP_JUMP_OTHER_LABEL = '<label>Em todos outros casos</label>';

export const STEP_CLASSES = {
  welcome: STEP_WELCOME_CLASS,
  'multiple-choice': STEP_MULTIPLE_CHOICE_CLASS,
  'yes-no': STEP_YES_NO_CLASS,
  text: STEP_TEXT_CLASS,
  email: STEP_FORM_EMAIL_CLASS,
  redirect: STEP_REDIRECT_CLASS,
  thanks: STEP_THANKS_CLASS,
};

export const STEP_CLASSES_DEFINITIONS = {
  [STEP_WELCOME_CLASS]: 'fill:#dc9f99;',
  [STEP_MULTIPLE_CHOICE_CLASS]: 'fill:#7AA2E4;',
  [STEP_TEXT_CLASS]: 'fill:#abd684;',
  [STEP_YES_NO_CLASS]: 'fill:#CF9AF1;',
  [STEP_FORM_EMAIL_CLASS]: 'fill:#54CF9F;',
  [STEP_REDIRECT_CLASS]: 'fill:#F4B786;',
  [STEP_OPTION_CLASS]: 'fill:#FFF,stroke-width:1px;',
  [STEP_JUMP_CLASS]: 'fill:#FFF,stroke-width:1px;',
  [STEP_THANKS_CLASS]: 'fill:#DC9F99;',
};



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/config.js
 **/